import type {
  GetJobTotalPriceAggregationsResponse as JobTotalPriceAggregationsProto,
  GetJobTotalsResponse as JobTotalsProto,
  GetJobTotalStatusAggregationsResponse as JobTotalStatusAggregationsProto,
} from '@taxfyle/api-internal/internal/job_stats_pb'
import { safeDecimalToNumber } from '@/utils/grpc-util'
import type {
  JobTotals,
  JobTotalStatusAggregations,
  JobsTotalPricing,
} from './job-totals'

export function mapJobTotalsProtoToJobTotals(proto: JobTotalsProto): JobTotals {
  return {
    actives: proto.getActives(),
    total: proto.getTotal(),
  }
}

export function mapJobTotalStatusAggregationsProtoToJobTotalStatusAggregations(
  proto: JobTotalStatusAggregationsProto,
): JobTotalStatusAggregations {
  return {
    infoGathering: proto.getInfoGathering(),
    pending: proto.getPending(),
    closed: proto.getClosed(),
    idle: proto.getIdle(),
    onHold: proto.getOnHold(),
    unclaimed: proto.getUnclaimed(),
    claimed: proto.getClaimed(),
    underConstruction: proto.getUnderConstruction(),
  }
}

export function mapJobTotalPriceAggregationsProtoToJobsTotalPricing(
  proto: JobTotalPriceAggregationsProto,
): JobsTotalPricing {
  return {
    submittedJobsTotalPrice: safeDecimalToNumber(
      proto.getSubmittedjobstotalprice(),
    ),
    closedJobsTotalPrice: safeDecimalToNumber(proto.getClosedjobstotalprice()),
  }
}
